import { MAX_QUESTION_CHARS } from 'src/app/shared/constants/chat.constants';

/**
 * Trims `value` and validates it against `maxLength`. Returns the trimmed content, or null when it is
 * empty/whitespace-only or exceeds the cap. Shared by the composer's send/report actions and the
 * edit-and-resend flow so every entry point into a chat turn rejects the same inputs.
 */
export function normalizeChatMessageContent(value: string, maxLength: number = MAX_QUESTION_CHARS): string | null {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > maxLength) {
    return null;
  }
  return trimmed;
}
